import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type CustomReportResults } from "shared/api/types/pagination";
import { type SocietyProfileReportInputParams } from "shared/api/types/society/[societyId]/profiles/[profileId]/reports/[reportId]";
import { type CustomReportResponseType } from "shared/api/types/society/[societyId]/reports/[reportId]/index";
export const getSocietyProfileReportIdContract: BaseApiContract<
  SocietyProfileReportInputParams,
  undefined,
  CustomReportResults<CustomReportResponseType>
> = {
  method: HttpMethod.GET,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/reports/[reportId]",
  paramsType: {} as SocietyProfileReportInputParams,
  responseType: {} as CustomReportResults<CustomReportResponseType>,
};
